import React from "react";
import { CSSTransition } from "react-transition-group";
import { useSnapshot } from "valtio";

import { designStore, generalConfigStore } from "@store";

import { ContentPreview } from "@components/Common/Design/Preview/PersonalizedInformationModes/ContentPreview";

import { Preview } from "@components/Common/Design/Preview";

export function InformationModesPreview(): JSX.Element {
    const { chosenTransition, isAnimationIn } = useSnapshot(generalConfigStore);
    const { isInformationModesPersonalized } = useSnapshot(designStore);

    return (
        <div
            className="d-flex justify-content-center align-items-center p-1 m-2"
            style={{
                backgroundColor: "#363636",
                borderRadius: "10px",
                height: "740px",
                width: "448px",
            }}
        >
            <CSSTransition
                in={isAnimationIn}
                appear={true}
                timeout={chosenTransition.timeout}
                classNames={chosenTransition.className}
            >
                <div
                    style={{
                        backgroundColor: "#FFFFFF",
                        height: "725px",
                        width: "430px",
                        borderRadius: "10px",
                    }}
                >
                    {isInformationModesPersonalized === true ? (
                        <ContentPreview />
                    ) : (
                        <Preview />
                    )}
                </div>
            </CSSTransition>
        </div>
    );
}
